import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import swal from "sweetalert2";
import { home } from "../../../routesConfiguration/paths";

const LegacyReservationRedirect = () => {
    useEffect(() => {
        swal.fire({
            type: "info",
            title: "Reservations have moved to Odoo",
            text: "This legacy booking page has been retired. Please create reservations in Odoo.",
        });
    }, []);

    return <Redirect to={home} />;
};

export default LegacyReservationRedirect;
